import type { OystehrClientRequest } from './client/client';
import { OystehrConfig } from './config';
import * as errors from './errors';
import { Oystehr as OystehrBase } from './resources/classes';

export * from './resources';

export type { OystehrClientRequest };
export type { OystehrConfig };

// HACK: ideally we would only have to do this for CommonJS
// where default + named exports are not allowed; however,
// our ancient tsc settings are somehow grabbing js from
// dist/esm and types from dist/cjs

class Oystehr extends OystehrBase {
  static OystehrFHIRError = errors.OystehrFHIRError;
  static OystehrSdkError = errors.OystehrSdkError;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace Oystehr {
  export type OystehrFHIRError = errors.OystehrFHIRError;
  export type OystehrSdkError = errors.OystehrSdkError;
}

export default Oystehr;
